















import { Nullable } from '@homeserve/od-typings/utils';
import { addressHelper, IPostCodeSearchResult } from '@homeserve/vue-api-plugin';
import debounce from 'lodash/debounce';
import { Component, Emit, Model, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PostCodeField extends Vue {
  private static MIN_LENGTH = 3;

  @Model('change', { type: String, required: true })
  public readonly postCode!: string;

  public loading = false;
  public postCodes: IPostCodeSearchResult[] = [];
  public selectedPostCode: Nullable<IPostCodeSearchResult> = null;

  public debounceFetchPostCodes = debounce((postCode: string) => this.fetchPostCodes(postCode), 200);

  public async fetchPostCodes(postCode: string) {
    if (postCode.length < PostCodeField.MIN_LENGTH) {
      return;
    }

    this.loading = true;

    const { error, result } = await addressHelper.fetchPostCodeSearchResults(this.$store, {
      country: 'FR',
      input: postCode,
    });

    this.loading = false;

    if (error) {
      return;
    }

    this.postCodes = Array.isArray(result) ? result : [];
  }

  public get items() {
    if (this.selectedPostCode && !this.postCodes.length) {
      return [this.selectedPostCode];
    }

    return this.postCodes;
  }

  @Emit('change')
  public updatePostCode(postCode?: string) {
    this.selectedPostCode = null;

    return postCode || '';
  }

  @Watch('postCode', { immediate: true })
  private onPostCodeChanged(postCode: string, oldPostCode: string) {
    if (!postCode || postCode === oldPostCode) {
      return;
    }

    this.selectedPostCode = {
      postCode,
      summary: postCode,
      town: '',
    };
  }
}
